export enum NotificationTypeEnum {
  LEVEL_UP = 'levelUp',
  RANK_UP = 'rankUp',
  MISSION = 'mission',
}
